export default __webpack_public_path__ + "static/media/wheel_3.72f22d3e.png";